import ExportTableToCSV from "./exportTableToCSV";
import ExportTableToPDF from "./exportTableToPDF";
import { ActionGroup } from '../TableActions';

function ProfileTableExportFunctions({ tableData, headers, userData }) {

  return (
    <ActionGroup>
      <ExportTableToCSV tableData={tableData} headers={headers.map(c => ({ label: c.Header, key: c.id }))} ></ExportTableToCSV>
      <ExportTableToPDF tableData={tableData.map(row => Object.values({
        id: row.drone,
        purpose: row.purpose,
        startPosition: row.startPosition,
        endPosition: row.endPosition,
        flightStart: row.flightStart,
        flightEnd: row.flightEnd,
        incident: row.incident
      }))} headers={headers.map(h => (h.Header))} missionName={userData} missionDate={"Dnes"} title={"Drone User Log"} type={"UsrLog"} ></ExportTableToPDF>
    </ActionGroup>
  )
}
export default ProfileTableExportFunctions